module.exports = __webpack_public_path__ + "img/128.dcd589d4.png";